export const SIP_PROVIDER = {
	SOMIC: 'somic',
	ENIO: 'enioCaller',
};

const SIP_MOBILE_BREAKPOINT = 799;

export const SIP_MEDIA_QUERY_DESKTOP = `(min-width: ${SIP_MOBILE_BREAKPOINT + 1}px)`;
export const SIP_MEDIA_QUERY_MOBILE = `(max-width: ${SIP_MOBILE_BREAKPOINT}px)`;
